module.exports = __webpack_public_path__ + "assets/facebook-blue-5f2c93.svg";